import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { TTS_ACTIVE_ITEM_BACKGROUND_PADDING } from './consts'

export const TtsListItemWrapper = styled.div<{
  $isActive: boolean
  $isLoading: boolean
}>`
  padding: ${TTS_ACTIVE_ITEM_BACKGROUND_PADDING}px;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background: ${({ $isActive, $isLoading }) =>
    $isActive || $isLoading ? COLORS.primaryLight : COLORS.white};
  transition: background 0.2s linear;
  height: ${({ $isLoading }) => ($isLoading ? '44px' : 'auto')};
`
